import { Link, useRouterState } from "@tanstack/react-router";
import { RouteUrl } from "@/configs/router/routes";
import MaterialIcon from "@/components/general/common/MaterialIcon";

const NAV_ITEMS = [
    {
        to: RouteUrl.Dashboard,
        label: "Dashboard",
        icon: "dashboard",
        prefix: RouteUrl.Dashboard,
        onboardingId: "onboarding-nav-dashboard-mobile",
    },
    {
        to: RouteUrl.Players,
        label: "Players",
        icon: "groups",
        prefix: RouteUrl.PlayerProfile,
        onboardingId: "onboarding-nav-players-mobile",
    },
    {
        to: RouteUrl.TournamentAnalysis,
        label: "Tournaments",
        icon: "emoji_events",
        prefix: RouteUrl.TournamentAnalysis,
        onboardingId: "onboarding-nav-tournaments-mobile",
    },
    {
        to: RouteUrl.Leaderboards,
        label: "Leaderboards",
        icon: "leaderboard",
        prefix: RouteUrl.Leaderboards,
        onboardingId: "onboarding-nav-leaderboards-mobile",
    },
];

const NavigationBottom = () => {
    const currentPath = useRouterState({ select: (select) => select.location.pathname });

    const isActive = (to: string, prefix: string) => currentPath === to || currentPath.startsWith(prefix + "/");

    return (
        <nav className="lg:hidden fixed bottom-0 left-0 right-0 bg-surface-container-lowest shadow-[0_-4px_20px_rgba(5,0,102,0.08)] flex justify-around items-center h-16 z-50 px-4">
            {NAV_ITEMS.map((item) => {
                const active = isActive(item.to, item.prefix);
                return (
                    <Link
                        key={item.to}
                        id={item.onboardingId}
                        to={item.to}
                        className={`flex flex-col items-center gap-1 min-w-[3rem] transition-colors ${
                            active ? "text-primary" : "text-on-surface-variant"
                        }`}
                    >
                        <MaterialIcon name={item.icon} fill={active} className="text-2xl leading-none" />
                        <span className="text-[9px] font-headline font-bold uppercase tracking-wide">{item.label}</span>
                    </Link>
                );
            })}
        </nav>
    );
};

export default NavigationBottom;
